import { reportPages } from "./reportPageInfo";
import { schedulePages } from "./schedulePageInfo";

export const APP_NAME = "Classora 授業報告";

export const getPageInfo = (appName = "report") => {
  switch (appName) {
    case "schedule":
      return schedulePages;
    case "report":
    default:
      return reportPages;
  }
};
